import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { FileSelection } from '../../containers/Files';
import NavigationTabs from '../nav/NavigationTabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { COLORS } from '../../styles/colors';
import { AlertJsMessage } from './../../helpers.js';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

class Form extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			dataLoaded: false,
			editExercise: null,
			isValidating: false,
			submitAction: 'create',
			isAudioDelete: false,
			formData: {
				name: '',
				description: '',
				equipmentId: null,
				partId: null,
				imgUrl: '',
				videoUrl: '',
				audioUrl: '',
				isHideFromLibrary: false
			},
		};
	}
	componentDidMount() {
		this.props.fetch(this.props.user._id || localStorage.id, this.props.editId).then((res) => {
			const { editId, exercises, exercise } = this.props;
			if (editId) {
				const editExercise = exercise;
				if (editExercise) {
					this.setState({
						...this.state,
						dataLoaded: true,
						editExercise: editExercise,
						submitAction: 'edit',
						formData: {
							name: editExercise.name,
							description: editExercise.description,
							equipmentId: editExercise.equipmentId,
							partId: editExercise.partId,
							imgUrl: editExercise.imgUrl,
							videoUrl: editExercise.videoUrl,
							isHideFromLibrary: editExercise.isHideFromLibrary
						},
					});
				}
			} else {
				this.setState({
					...this.state,
					submitAction: 'create',
					dataLoaded: true,
				});
			}
		});
	}

	handleChange = field => event => {
		this.setState({
			...this.state,
			formData: {
				...this.state.formData,
				[field]: event.target.value,
			},
		});
	};


	handleHideLibrary = field => event => {
		this.setState({
			...this.state,
			formData: {
				...this.state.formData,
				[field]: event.target.checked,
			},
		});
	};


	handleOpen = () => {
		this.setState({ open: true });
	};

	handleClose = () => {
		this.setState({ open: false });
	};
	validateForm() {
		let formData = { ...this.state.formData };
		const lib_URL = '/library/exercises';
		const { addExercise, edit, editId, history, user, onClose } = this.props;
		const required = ['name', 'equipmentId', 'partId'];
		for (var i = 0; i < required.length; i++) {
			if (!formData[required[i]]) {
				AlertJsMessage(required[i] + ' is required.');
				return;
			}
		}
		const {
			type,
			selectedFile,
			previewVideoSrc,
			previewImageSrc,
		} = this.fileSelect.state;

		if (type === 'library') {
			if (selectedFile) {
				formData.fileId = selectedFile._id;
				formData.videoUrl = selectedFile.url;
				formData.screenShotUrl = selectedFile.screenShotUrl;
				if (
					this.audioSelection &&
					this.audioSelection.state &&
					this.audioSelection.state.audioName
				) {
					this.audioSelection.submitNewFile('audio').then(file => {
						this.setState({
							isAudioDelete: false
						});
						formData.audioUrl = file.url;
						formData.audioFileName = file.name;
						if (this.state.submitAction === 'create') {
							addExercise(formData, user.type).then(() => {
								setTimeout(() => {
									window.location.reload();
								});
							});
						} else {
							edit(editId, formData, user.type).then(() => {
								onClose && onClose();
								setTimeout(() => {
									window.location.reload();
								});
							});
						}
					});
				} else {
					if (this.state.submitAction === 'create') {
						addExercise(formData, user.type).then(() => {
							setTimeout(() => {
								window.location.reload();
							});
						});
					} else {
						formData.isAudioDelete = this.state.isAudioDelete;
						edit(editId, formData, user.type).then(() => {
							onClose && onClose();
							setTimeout(() => {
								window.location.reload();
							});
						});
					}
				}
			} else {
				AlertJsMessage('Please select a video.');
				return;
			}
		} else if (type === 'upload') {
			if (
				previewVideoSrc ||
				previewImageSrc ||
				this.audioSelection.state.name
			) {
				this.setState(
					{
						...this.state,
						isValidating: true,
					},
					() => {
						this.fileSelect.submitNewFile().then(file => {
							const isTranscoding = file.isTranscoding;
							const jobId = file.jobId;
							if (
								this.audioSelection &&
								this.audioSelection.state &&
								this.audioSelection.state.audioName
							) {
								this.audioSelection.submitNewFile('audio').then(fileData => {
									this.setState({
										isAudioDelete: false
									});
									formData.audioUrl = fileData.url;
									formData.audioFileName = fileData.name;
									formData.fileId = file._id;
									formData.videoUrl = file.url;
									formData.screenShotUrl = file.screenShotUrl;
									formData.isTranscoding = isTranscoding;
									formData.jobId = jobId;
									if (this.state.submitAction === 'create') {
										addExercise(formData, user.type).then(() => {
											history.push(lib_URL);
										});
									} else {
										edit(editId, formData, user.type).then(() => {
											onClose && onClose();
											history.push(lib_URL);
										});
									}
								});
							} else {
								formData.fileId = file._id;
								formData.videoUrl = file.url;
								formData.isTranscoding = isTranscoding;
								formData.jobId = jobId;
								formData.screenShotUrl = file.screenShotUrl;
								if (this.state.submitAction === 'create') {
									addExercise(formData, user.type).then(() => {
										history.push(lib_URL);
									});
								} else {
									formData.isAudioDelete = this.state.isAudioDelete;
									edit(editId, formData, user.type).then(() => {
										onClose && onClose();
										setTimeout(() => {
											window.location.reload();
										})
									});
								}
							}
						});
					}
				);
			} else {
				AlertJsMessage('Please upload a video.');
			}
		} else {
			AlertJsMessage('Please select or upload a video.');
		}
	}

	renderMenuOptions = option => (
		<MenuItem key={option._id} value={option._id}>
			{option.name}
		</MenuItem>
	);

	

	render() {
		const { formData, dataLoaded, editExercise, isAudioDelete } = this.state;
		const { equipment, cats, user, brand } = this.props;
		let showExerciseOption = false;
		if(brand && brand.isLibraryExerciseHide) {
			showExerciseOption = true;
		}
		return (
			<div>
				{this.props.hideNavigationTabs ? null : (
					<NavigationTabs
						title="Build"
						subtitle="Exercises"
						set="build"
						activeRoute="/build/exercise"
					/>
				)}
				{dataLoaded && (
					<React.Fragment>
						<TextField
							label="Name"
							value={formData.name}
							onChange={this.handleChange('name')}
							margin="dense"
							variant="outlined"
							inputProps={{ maxLength: 60 }}
						/>
						<TextField
							label="Description (Optional)"
							value={formData.description}
							onChange={this.handleChange('description')}
							margin="dense"
							variant="outlined"
							inputProps={{ maxLength: 250 }}
						/>
						{ showExerciseOption && 
							<FormControlLabel
								control={
									<Checkbox
										onChange={this.handleHideLibrary('isHideFromLibrary')}
										defaultChecked={formData.isHideFromLibrary}
										inputProps={{
											'name': 'isHideFromLibrary',
										}}
									/>
								}
								name = "isHideFromLibrary"
								label="Hide Exercise From App's Library."
								/>
						}
						<TextField
							select
							label="Select Equipment"
							value={formData.equipmentId}
							onChange={this.handleChange('equipmentId')}
							margin="dense"
							variant="outlined"
						>
							{Object.values(equipment).map(this.renderMenuOptions)}
						</TextField>

						<TextField
							select
							label="Select Body Target"
							value={formData.partId}
							onChange={this.handleChange('partId')}
							margin="dense"
							variant="outlined"
						>
							{Object.values(cats).map(this.renderMenuOptions)}
						</TextField>
						<FileSelection
							userData={user}
							fileType="video"
							category="exerciseVideo"
							previewType="phone"
							isShowHelpIcon={false}
							selectedFileId={editExercise ? editExercise.fileId : 0}
							ref={ref => {
								this.fileSelect = ref ? ref.getWrappedInstance() : null;
							}}
						/>
						<FileSelection
							userData={user}
							fileType="audio"
							category="exerciseAudio"
							previewType="phone"
							isShowHelpIcon={false}
							selectedFileId={editExercise ? editExercise.fileId : 0}
							ref={ref => {
								this.audioSelection = ref ? ref.getWrappedInstance() : null;
							}}
						/>

						{editExercise && editExercise.audioUrl &&  !isAudioDelete && (
							<div style={{ marginBottom: '10px' }}>
								<span className="link">
									{editExercise.audioFileName}
								</span>
								<span
									className="link"
									onClick={() => this.setState({
										isAudioDelete: true
									})}
									style={{ marginLeft: 5 }}>
									<FontAwesomeIcon icon={faTrash} title={'Delete'}
										style={{marginRight: 5, color: COLORS.orange}}/>
									</span>
							  </div>
							
						)}

						<Button
							disabled={this.state.isValidating}
							onClick={() => this.validateForm()}
							variant="contained"
							color="primary"
						>
							{this.state.editExercise ? 'Update Exercise' : 'Add Exercise'}
						</Button>
					</React.Fragment>
				)}
			</div>
		);
	}
}
export default withRouter(Form);



// WEBPACK FOOTER //
// ./src/components/exercises/Form.js